import 'angular:locale/data:en-US';
import 'angular:locale/data:fr-BE';
import 'angular:locale/data:nl-BE';
import 'angular:locale/data:en-BE';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
